import React from 'react';
import {
    DialogActions,
    DialogTitle,
    DialogContent,
    Button,
    List,
    ListItem,
    ListItemText,
    ListItemSecondaryAction
} from '@material-ui/core';
import { Dialog } from 'components/shared/Dialog';
import strings from 'strings';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';

// Mock JSON data
const mockCosts = [
    { name: 'FMCSA', cost: 5 },
    { name: 'SOS', cost: 3 },
    { name: 'ID Verify', cost: 2 },
    { name: 'Business Search', cost: 4 },
    { name: 'Full Business Report', cost: 4 },
    { name: 'Comprehensive Indiv Report', cost: 4 },
    { name: 'Credit Memo', cost: 4 },
];

const ReportsCostDialog = ({ open, onClose }) => {
    return (
        <Dialog
            open={open}
            fullWidth={true}
            maxWidth='sm'
        >
            <DialogTitle>
                {strings.REPORTS_COST || 'Reports Cost'}
            </DialogTitle>
            <DialogContent>
                <List>
                    {mockCosts.map((item, idx) => (
                        <ListItem key={idx} divider>
                            <ListItemText primary={item.name} />
                            <ListItemSecondaryAction style={{ right: 0 }}>
                                <span style={{ display: 'flex', alignItems: 'center', fontWeight: 500 }}>
                                    {item.cost}
                                    <AttachMoneyIcon style={{ marginLeft: 4, color: 'var(--status-approved)' }} fontSize="small" />
                                </span>
                            </ListItemSecondaryAction>
                        </ListItem>
                    ))}
                </List>
            </DialogContent>
            <DialogActions>
                <Button color='primary' onClick={onClose}>
                    Done
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ReportsCostDialog;